/**
 * Login and SSO utilities
 * SSO pending state need to be stored in sessionStorage for standalone tag page state
 */

import { SSO_PENDING_KEY, SSO_PENDING_TIMEOUT, LOGIN_CACHE_TIMEOUT } from './constants'


/**
 * Set SSO started timestamp
 */
export const markSSOPending = () => {
    sessionStorage.setItem(SSO_PENDING_KEY, Date.now().toString())
}

/**
 * Check if SSO is still pending (within timeout)
 * @returns {boolean} True if SSO was started within timeout period
 */
export const isSSOPending = () => {
    const ssoStartedTime = sessionStorage.getItem(SSO_PENDING_KEY)
    if (!ssoStartedTime) return false
    return (Date.now() - parseInt(ssoStartedTime, 10)) < SSO_PENDING_TIMEOUT
}

/**
 * Clear SSO started flag
 */
export const clearSSOPending = () => {
    sessionStorage.removeItem(SSO_PENDING_KEY)
}


/**
 * Validates if a cached timestamp is still within the timeout period
 * @param {number} timestamp - The timestamp to validate (in milliseconds)
 * @param {number} [timeoutMs=LOGIN_CACHE_TIMEOUT] - The timeout duration in milliseconds (default: 5 minutes)
 * @returns {boolean} True if the timestamp is valid and within the timeout period, false otherwise
 */
export function isCacheValid(timestamp, timeoutMs = LOGIN_CACHE_TIMEOUT) {
    if (!timestamp) return false
    return Date.now() - timestamp < timeoutMs
}

/**
 * Check if cached authentication state is valid
 * @param {Object} cachedAuthState - Cached auth state object
 * @returns {boolean} True if authenticated and cache is still valid
 */
export const isAuthStateValid = (cachedAuthState) => {
    return cachedAuthState?.authenticated && isCacheValid(cachedAuthState.timestamp)
}

/**
 * Whether the current page is the login page
 * @returns {boolean}
 */
export const isOnLoginPage = () => {
    return window.location.pathname.includes('/login')
}

/**
 * Redirect to login page if not already on it
*/
export const redirectToLogin = () => {
    if (!isOnLoginPage()) {
        window.location.href = '/login'
    }
}

